"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// Deprecated, import directly from the component folder now.
tslib_1.__exportStar(require("../../Autofill/Autofill"), exports);
//# sourceMappingURL=BaseAutoFill.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/pickers/AutoFill/BaseAutoFill.js
// module id = 1017
// module chunks = 0